import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { messager } from "./events";
export var loadJS = function loadJS(url, cb) {
  var head = window.document.getElementsByTagName('head')[0];
  var js = window.document.createElement('script');
  js.setAttribute('type', 'text/javascript');
  js.setAttribute('async', 'async');
  js.setAttribute('src', url);
  js.onload = cb;
  head.appendChild(js);
};
export var loadJSArr = function loadJSArr(urls, cb) {
  var done = 0;
  if (typeof urls === 'string') urls = [urls];
  var _urls = urls,
    length = _urls.length;
  urls.map(function (url) {
    return loadJS(url, function () {
      ++done >= length && cb();
    });
  });
};
export var WaitJsLoaded = /*#__PURE__*/function () {
  function WaitJsLoaded(native, res, cb, option) {
    _classCallCheck(this, WaitJsLoaded);
    _defineProperty(this, "__loaded", void 0);
    _defineProperty(this, "waitArr", void 0);
    this.native = native;
    var that = this;
    res || (this.__loaded = true, cb && cb());
    this.waitArr = [];
    res && loadJSArr(res, function () {
      cb && cb();
      !(option && option.disableAutoInit) && that._init();
    });
  }
  _createClass(WaitJsLoaded, [{
    key: "_init",
    value: function _init() {
      this.__loaded = true;
      this.waitArr.map(function (f) {
        return f();
      });
      messager.$emit('ready');
    }
  }, {
    key: "_invokeCB",
    value: function _invokeCB(cb) {
      this.__loaded ? cb() : this.waitArr.push(cb);
    }
  }, {
    key: "_invoke",
    value: function _invoke(key, argv) {
      var _this = this;
      var cb = function cb() {
        if (_this.constructor.prototype.hasOwnProperty(key)) {
          return _this[key].apply(_this, argv);
        }
        if (_this.__sdk && _this.__sdk[key]) {
          return _this.__sdk[key].apply(_this.__sdk, argv);
        }
        return _this[key].apply(_this, argv);
      };
      this._invokeCB(cb);
    }
  }]);
  return WaitJsLoaded;
}();